// Sugar Alarm — Cycle 458: where a photo may come from, on this device.
//
// The kiosk is CAMERA-ONLY (operator decision 2026-10-02): it does not use
// on-device storage and there is no way to put pictures onto it, so every
// "choose from gallery" / "Upload" control is NOT RENDERED there — hidden,
// never disabled. "Take a photo", the preset grid and "Remove photo" stay.
//
// ⚠ THE ONE QUESTION IS "IS THIS THE KIOSK APK?", NEVER "IS THIS A KIOSK
// LAYOUT?". `variant === "kiosk"` is a LAYOUT answer: an A9+ running the
// standard phone app in landscape renders the kiosk variant (cycle 52/193
// step 0), and keying on it would hide that phone's gallery. The signal is
// `isNativeKioskShell()` (cycle 267 — kiosk-flavor plugins on the bridge),
// the same one every other kiosk-only behaviour reads.
//
// ⚠ WHEN IN DOUBT, IT IS A PHONE. A missing, unknown or failing signal shows
// the gallery: showing it on a kiosk is harmless (there is nothing to pick),
// hiding it on a phone is a broken feature. Only an EXPLICIT kiosk signal
// hides it — `isNativeKioskShell()` answers false for a missing bridge, an
// iOS shell, the standard Android flavor and a browser, and a throw is caught
// here and read as "phone".
//
// Every photo flow reads this module; none re-derives it.
import { isNativeKioskShell } from "./capacitor";

/** True only on the kiosk APK: gallery/upload controls are not rendered. */
export function cameraOnlyDevice(): boolean {
  try {
    return isNativeKioskShell() === true;
  } catch {
    return false;
  }
}

/** The inverse, for call sites that read better that way. */
export function galleryAllowed(): boolean {
  return !cameraOnlyDevice();
}

/** Shown in a gallery control's place on a kiosk flow with no camera path
 *  (display backgrounds). Plain text, never a button. */
export const ADD_FROM_PHONE_LINE = "Add it from your phone.";
